<template>
  <div class="scrollable-table-container">
    <loading :working="isLoading || !dataLoaded"></loading>
    <div class="text-center" style="margin:auto;" v-if="!isLoading && dataLoaded && !adulticides.length">No data for params given</div>
    <table  v-if="!isLoading && dataLoaded && adulticides.length">
      <thead>
        <tr>
          <td>
            <div class="select-all">
              <input
                type="checkbox"
                @click="checkOrUncheckAll"
                :checked="allChecked"
              />
              <span>Select All</span>
            </div>
          </td>
          <td>Application Date</td>
          <td>Spray Start/End</td>
          <td>Zone</td>
          <td>Site/Contract</td>
          <td>Chemical</td>
          <td>Applicator</td>
          <td>Truck</td>
          <td></td>
        </tr>
      </thead>
      <tbody >
        
        <tr v-for="adulticide in adulticides">
          <td>
            <input
              type="checkbox"
              @change="check(adulticide, $event)"
              :checked="adulticide.checked"
            />
          </td>
          <td>{{ formatDate(adulticide.date) }}</td>
          <td>
            {{ formatTimeOfDay(adulticide.startedAt) }} -
            {{ formatTimeOfDay(adulticide.endedAt) }}
          </td>
          <td>{{ adulticide.zoneName }}</td>
          <td>{{ adulticide.contractName }}</td>
          <td>{{ adulticide.chemicalName }}</td>
          <td>{{ adulticide.applicatorName }}</td>
          <td>{{ adulticide.truckName }}</td>
          <td>
            <router-link
              :to="{
                name: 'data-adulticide-details',
                params: { id: adulticide.id },
              }"
            >
              <i class="fa fa-ellipsis-h" style="margin-right: 10px"></i>
            </router-link>

            <a class="pointer text-danger" v-on:click="destroy(adulticide)">
              <i class="fa fa-times"></i>
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import AdulticideService from "@/services/AdulticideService";
import Form from "@/utils/form";
import loading from '@/components/loading';


export default {
  components: {
    loading
  },


  data: () => {
    return {
      form: new Form(AdulticideService, {}),
      isLoading: true,
      dataLoaded: false
    };
  },

  computed: {
    adulticides: function () {
      return this.$store.getters.filteredAdulticides;
    },

    allChecked: function () {
      return this.adulticides.every((adulticide) => adulticide.checked);
    },
  },

  watch: {
   '$store.getters.isLoading': {
      handler(newVal) {
       this.isLoading = newVal;
      }
    },
    '$store.getters.dataLoaded': {
      handler(newVal){
        this.dataLoaded = newVal;
      }
    },
    immediate: true
  },

  methods: {
    check: function (adulticide, event) {
      let checked = event.target.checked;
      this.$store.commit("checkAdulticide", { adulticide, checked });
    },

    destroy: function (adulticide) {
      let answer = confirm("Are you sure you want to delete this item?");
      if (!answer) return;

      AdulticideService.delete(adulticide.id).then((data) => {
        this.$store.commit("deleteAdulticide", adulticide.id);
      });
    },

    checkOrUncheckAll: function () {
      let checked = !this.allChecked;
      this.adulticides.forEach((adulticide) =>
        this.$store.commit("checkAdulticide", { adulticide, checked })
      );
    },

    formatDate: function (date) {
      return date.format("MM/DD/YYYY");
    },

    formatTimeOfDay: function (datetime) {
      return datetime.isValid() ? datetime.utc().format("hh:mm A") : "N/A";
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/scss/variables";
$outline-color: darken($gray-bg, 10%);

table {
  width: 100%;
  border: 2px solid $outline-color;
}

td {
  padding: 0.75rem 1rem;
  font-size: 0.85em;
}

thead {
  background: $white;
  border-bottom: 2px solid $outline-color;
  font-weight: bold;
}

tbody {
  tr {
    border-bottom: 1px solid $outline-color;
  }

  tr:nth-child(odd) {
    background: $gray-bg;
  }
}

.scrollable-table-container {
  height: 600px;
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
}

.select-all {
  display: flex;
  align-items: center;

  input[type="checkbox"] {
    margin: 0 0.5rem 0 0;
  }
}
</style>
